import { checkJsonProp } from '@utilities';
import { Notification } from '@components';
import { OnboardingFlowHandlerActions } from '@redux/Services/OnboardingFlowHandler/actions';
import { history, routerPath } from '@config';
import { notification } from 'antd';
import { AuthConstants } from '@redux';

const ERROR_CODES = {
  UNKOWN_ERROR: 'unknown_error'
};

const ERROR_ACTIONS = ['SMARTID_ERROR', 'BIOMETRICS_ERROR', 'MOBILEID_ERROR', 'EIDEASY_INIT_ERROR'];

export const serverErrorsMiddleware = (store) => (next) => (action) => {
  if (!action) return;

  const { type } = action;
  const matches = /(.*)_(ERROR)/.exec(type);
  const result = next(action);
  const state = store.getState();

  if (!matches) {
    return result;
  }

  const errorStatus = result?.error?.response?.status;
  const traceId = result?.error?.response?.headers?.['x-traceid'];

  if (errorStatus === 401) {
    sessionStorage.clear();

    store.dispatch(OnboardingFlowHandlerActions.setTraceId(traceId));

    Notification({
      type: 'error',
      message: 'AuthErrors',
      description: traceId
    });

    history.push(routerPath.login);
    return;
  }

  if (action.error?.response?.status === 400) {
    if (ERROR_ACTIONS.includes(action.type)) {
      store.dispatch({
        type: AuthConstants.SET_LOGIN_NOTIFICATION,
        payload: {
          code: 'errorCode',
          message: 'errorMessage'
        }
      });
      return result;
    }

    notification.error = action.error.response?.data;

    Notification({
      type: 'error',
      message: action.error.response?.data?.errorCode,
      description: traceId,
      noTranslateDescription: true
    });
  }

  if (ERROR_ACTIONS.includes(action.type)) {
    return result;
  }

  for (const key in state) {
    const error = checkJsonProp(state[key], 'errors');
    if (!error) continue;

    let errorMessage = checkJsonProp(error, 'response.data.message') || error.message;
    let errorCode = checkJsonProp(error, 'response.data.errorCode') || ERROR_CODES.UNKOWN_ERROR;

    store.dispatch(OnboardingFlowHandlerActions.setTraceId(traceId));

    Notification({
      type: 'error',
      message: errorCode,
      description: traceId,
      noTranslateDescription: true
    });
  }

  return result;
};
